import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'

export const voiceUrl = 'voice'

export interface VoiceModel extends DjangoModel {
  name: string
  readingSpeed: string
  isDefault: boolean
}

const {
  slice: voiceSlice,
  thunks: voiceThunks,
  adapter: voiceAdapter,
  selectors,
} = createGenericSlice<VoiceModel>(
  'voice',
  voiceUrl,
  {}
  //voiceExtraReducers  Initial state can be customized if needed
)

// export const voiceAdapterExport = voiceAdapter

export const { selectAll: selectAllVoices, selectById: selectVoiceById } =
  voiceAdapter.getSelectors<RootState>((state: RootState) => state.voice)

export const { fetchAll: fetchAllVoices } = voiceThunks
export const {
  selectLoading: selectVoiceLoading,
  selectIsIdInProgress: selectIsVoiceIdInProgress,
  selectError: selectVoiceError,
} = selectors

export default voiceSlice.reducer
